import {Model} from "ords/dist/model/model";

export class GroupPairGroupCourses extends Model {

}

export const GroupPairGroupCoursesConfig = {
    name: 'group_pair_group_courses',
    model: GroupPairGroupCourses,
    relations: [
        {name: 'course', model_name: 'course', type: 'hasOne'},
    ]
}
